export enum menuCategoriesEnum {
  nonCategory,
  food,
  lunch,
  alcohols,
  soda,
  child,
  christmas,
}
